import CaseFolders from "../CaseFolders";
import Notifications from "../Notifications";
import Overview from "../Overview";
import PaymentHistory from "../PaymentHistory";
import Requests from "../Requests";
import Settings from "../Settings";
import CreateCase from "../internals/case-folder/CreateCase";
import FileAsDefendant from "../internals/case-folder/FileAsDefendant";
import FileAsThirdParty from "../internals/case-folder/FileAsThirdParty";
import FileDefenceProcess from "../internals/case-folder/FileDefenceProcess";
import FileNewProcess from "../internals/case-folder/FileNewProcess";
import SearchResult from "../internals/case-folder/SearchResult";
import ViewCaseFolder from "../internals/case-folder/ViewCaseFolder";

export const LawyerRoute = [
  {
    title: "Overview",
    path: "/lawyer/overview",
    component: Overview,
  },
  {
    title: "Case Folders",
    path: "/lawyer/case-folders",
    component: CaseFolders,
  },
  {
    title: "Create Case",
    path: "/lawyer/case-folders/create",
    component: CreateCase,
  },
  {
    title: "View Case Folder",
    path: "/lawyer/case-folders/view",
    component: ViewCaseFolder,
  },
  {
    title: "Create Case",
    path: "/lawyer/case-folders/create",
    component: CreateCase,
  },
  {
    title: "Create Case",
    path: "/lawyer/case-folders/view/file-new-process",
    component: FileNewProcess,
  },
  {
    title: "File Defence Process",
    path: "/lawyer/case-folders/view/file-defence-process",
    component: FileDefenceProcess,
  },
  {
    title: "File Defence Process",
    path: "/lawyer/case-folders/file-defendant-process",
    component: FileAsDefendant,
  },
  {
    title: "File Defence Process",
    path: "/lawyer/case-folders/file-third-party-process",
    component: FileAsThirdParty,
  },
  {
    title: "Create Case",
    path: "/lawyer/case-folders/search-result",
    component: SearchResult,
  },
  {
    title: "Request",
    path: "/lawyer/request",
    component: Requests,
  },
  {
    title: "Payment history",
    path: "/lawyer/payment-history",
    component: PaymentHistory,
  },
  {
    title: "Notification",
    path: "/lawyer/notification",
    component: Notifications,
  },
  {
    title: "Setting",
    path: "/lawyer/setting",
    component: Settings,
  },
];
